import ca from "date-fns/esm/locale/ca/index.js";
import { LimaCompanyID } from "../lib/lima/LimaCompanyID";
import { LimaShopID } from "../lib/lima/LimaShopID";
import textConfig from "../lib/textConfig.json";

const constantsName = "Constants";

export const getTextByKey = (key: string) => {
  return textConfig[key as keyof object] || null;
};

export const getLimaURLByShopId = (
  limaShopId: LimaShopID,
): string  => {
  switch(limaShopId){
    case  LimaShopID.Apotea: return "https://la.site.se"
    case  LimaShopID.HappyYachting: return "https://la.happyyachting.com"
    case  LimaShopID.BabylandFi:
    case  LimaShopID.BabylandNo:
    case  LimaShopID.Babyland: return "https://lima.babyland.se"
    case  LimaShopID.Delitea: return "https://lima.delitea.se"
    case  LimaShopID.WidforssNo:
    case  LimaShopID.WidForss: return "https://lima.widforss.se"
    case  LimaShopID.SmartaSakerCom:
    case  LimaShopID.SmartaSakerNo:
    case  LimaShopID.SmartaSaker: return "https://lima.smartasaker.se"
    default: return "https://la.site.se/"
  }
}

export const getTextByConstant = (
  constant: object,
  value: string | number,
  postfix?: string
): string | null => {
  let constantKey =
    constant &&
    Object.keys(constant).find((key: string) => constant[key as keyof object] === value);
  if (!constantKey) {
    console.log("no key found for the provided constant/value");
    return null;
  }

  if (postfix) constantKey = `${constantKey}.${postfix}`;

  return textConfig[constantsName][constantKey as keyof object] || null;
};
